import { render, staticRenderFns } from "./CosignAddress.vue?vue&type=template&id=11964830&"
import script from "./CosignAddress.vue?vue&type=script&lang=js&"
export * from "./CosignAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports